import { createContext } from 'react';
import { IItemForGetShortInfo, TLanguageIDs, IUpdateGameCategory, IGameCategoryTranslation } from 'types';

export type TEditGameCategoryVisibleForm = 'mainForm' | 'translations';
export type TTypeOfEditGameCategoryModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error'
	| 'someTranslationIsEmpty';

export interface IInitialFormData {
	name: string;
	IDsSelectedLanguages: TLanguageIDs[];
	translations: IGameCategoryTranslation[];
}

export interface IEditGameCategoryState {
	needRefetchData: boolean;
	initialFormData: IInitialFormData | null;
	categoryID: string;
	visibleForm: TEditGameCategoryVisibleForm;
	name: string;
	fetchedLanguages: IItemForGetShortInfo[];
	IDsSelectedLanguages: TLanguageIDs[];
	dataForSubmit: IUpdateGameCategory | null;
	typeOfModalWindow: TTypeOfEditGameCategoryModalWindow;
	selectedTranslationTab: TLanguageIDs | null;
	translations: IGameCategoryTranslation[];
}

export const editGameCategoryInitialState: IEditGameCategoryState = {
	needRefetchData: false,
	initialFormData: null,
	categoryID: '',
	visibleForm: 'mainForm',
	name: '',
	fetchedLanguages: [],
	IDsSelectedLanguages: [],
	dataForSubmit: null,
	typeOfModalWindow: null,
	selectedTranslationTab: null,
	translations: [],
};

export interface IEditGameCategoryContext extends IEditGameCategoryState {
	refetchData(value: boolean): void;
	changeVisibleForm(value: TEditGameCategoryVisibleForm): void;
	changeName(value: string): void;
	setFetchedLanguages(value: IItemForGetShortInfo[]): void;
	setIDsLanguages(value: TLanguageIDs[]): void;
	setDataForSubmit(data: IUpdateGameCategory | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditGameCategoryModalWindow): void;
	setTranslationTab(value: TLanguageIDs | null): void;
	changeNameTranslation(languageId: TLanguageIDs, value: string): void;
	resetFields(): void;
}

export const EditGameCategoryContext = createContext<IEditGameCategoryContext>({
	refetchData: () => undefined,
	changeVisibleForm: () => undefined,
	changeName: () => undefined,
	setFetchedLanguages: () => undefined,
	setIDsLanguages: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setTranslationTab: () => undefined,
	changeNameTranslation: () => undefined,
	resetFields: () => undefined,
	...editGameCategoryInitialState,
});
